//bradley


import React, { useEffect, useState, useRef, useMemo, ChangeEventHandler } from "react";
import { Button, MenuItem, Select, TextField, FormControl, InputLabel, ToggleButtonGroup, ToggleButton,AlertColor,FormHelperText } from "@mui/material";
import { Policy, Address, Vehicle } from "../objects/policy";
import { VehicleService } from "../services/VehicleService";
import MakeDropDown from "./vehicles/MakeDropDown";
import ModelDropDown from "./vehicles/ModelDropDown";
import debounce from "lodash/debounce";
import { addErrorMessage } from "../pages/quoting/Quote";

export class VehicleValidate {
    hasVin: boolean = true;
    hasYear: boolean = true;
    hasMake: boolean = true;
    hasModel: boolean = true;
    
    hasAnnualMileage: boolean = true;
    hasVinLength: boolean = true;
    
    vinError = "VIN is Required";
    yearError = "Year is Required";
    makeError = "Make is Required";
    modelError = "Model is Required";
    
    annualMilesError = "Annual Miles are Required";

    vinLengthError = "VIN must be 17 characters";
}

function EditVehicleForm(props: any) {
    const vehicleService = new VehicleService();

    const { 
        isVisible,
        parent,
        action,
        currentKey, 
        vehicles,
        containerKey, 
        carNumber, 
        policyState, 
        policy,
        onCloseAction,
        onSaveAction,
        onUpdateVehicleAction
    } = props;


    const [isSaveDisabled, setIsSavedDisabled] = useState<boolean>(false);
    var years: number[] = vehicleService.getYears();
    const [makes, setMakes] = useState<string[]>([]);
    const [models, setModels] = useState<string[]>([]);
    const [editCurrentKey, setEditCurrentKey] = useState<string>(containerKey);
    const [isExpand, setIsExpand] = useState<boolean>(false);
    // const [policy, setPolicy] = useState<Policy>(new Policy());

    const [vehicleVin, setVehicleVin] = useState<string>("");
    const [vehicleYear, setVehicleYear] = useState<number | "">(0);
    const [vehicleMake, setVehicleMake] = useState<string>("");
    const [vehicleModel, setVehicleModel] = useState<string>("");
    const [vehicleStyle, setVehicleStyle] = useState<string>("");
    const [annualMileage, setAnnualMileage] = useState<string>("");
    
    const [validationObject, setValidation] = useState<VehicleValidate>(new VehicleValidate());
    const[errors, setErrors] = useState<string[]>([]);
    const[isToastOpen, setIsToastOpen] = useState(false);
    const[toastSeverity, setToastSeverity] = useState<AlertColor>("success");

    useEffect(() => {
        setIsExpand(isVisible);
        if(isVisible && action === "NEW"){
            setAnnualMileage(process.env.REACT_APP_DEFAULT_ANNUAL_MILEAGE ?? "8000");
        }

        if (isVisible && action == "EDIT") {            
            var vehicle = new Vehicle();
            var car = vehicle.getVehicle(vehicles, parseInt(carNumber?.toString()));

            var tmpMakes: string[] = [];
            tmpMakes.push(car.make);

            var tmpModels: string[] = [];
            tmpModels.push(car.model);

            setMakes(tmpMakes);
            setModels(tmpModels);

            
            setVehicleVin(car.vin);
            setVehicleYear(car.year);
            setVehicleMake(car.make);
            setVehicleModel(car.model);

            if(car.annualMileage > 0){
                setAnnualMileage(car.annualMileage.toString())
            }
        }
    }, [isVisible,isExpand]);


    function onYearChange(year: number) {
        setVehicleYear(year);

        setMakes([]);
        setModels([]);
        
        vehicleService.getMakes(policyState, year).then((data)=>{
            if(data.ok){
                data.json().then((makesData)=>{
                    setMakes(makesData);
                })
            }
            
        });
    }

    function onMakeChangeAction(year: number, make: string) {
        setVehicleMake(make);
        setValidation({...validationObject, hasMake: (make ?? "")!==""});
        addErrorMessage((make ?? "")==="", validationObject.makeError, errors, setErrors);

        vehicleService.getModels(policyState, year, make).then((data)=>{
            if(data.ok){
                data.json().then((modelsData)=>{
                    setModels(modelsData);
                })
            }
            
        });
    }

    function onModelChangeAction(year: number, make: string, model: string) {
        setVehicleModel(model);
        setValidation({...validationObject, hasModel: (model ?? "")!==""});
        addErrorMessage((model ?? "")==="", validationObject.modelError, errors, setErrors);
    }

    function onVinBlur(vin: string){
        if(vin.length < 10 || (vin.length > 10 && vin.length < 17)){
            return;
        }

        setIsSavedDisabled(true)
        vehicleService.getVehicleByVin(policyState, vin).then((data)=>{

            if(data.ok){
                data.json().then((parsedData)=>{

                    setVehicleYear(parsedData.year);
                    setVehicleMake(parsedData.make);

                    var tmpMakes: string[] = [];
                    tmpMakes.push(parsedData.make);
                    setMakes(tmpMakes);

                    setVehicleModel(parsedData.model);
                    
                    var tmpModels: string[] = [];
                    tmpModels.push(parsedData.model);
                    setModels(tmpModels);

                    setIsSavedDisabled(false)
                });    
            }else{
                setIsSavedDisabled(false)
            }

            
        });
    }

    function onSave(e: any){
        if(isSaveDisabled){
            return;
        }

        var isValid = isFormValid();
       
        if(!isValid) {
            setIsToastOpen(true);
            setToastSeverity("error");
            return;
        }

        switch(action){
            case "EDIT":
                updateExistingVehicle();
                break;
            default:
                createNewVehicle();
                break;
        }
        
        setEditCurrentKey("");

        setVehicleVin("");
        setVehicleYear("");
        setVehicleMake("");
        setVehicleModel("");
    }

    function createNewVehicle(){
        onSaveAction(vehicleVin, vehicleYear, vehicleMake, vehicleModel, "", "", annualMileage);
    }

    function updateExistingVehicle(){
        onUpdateVehicleAction(carNumber,vehicleVin, vehicleYear, vehicleMake, vehicleModel, "", "", annualMileage);

        onCloseAction("")
    }

    function onClose(e: any, carNum: number){
        setEditCurrentKey("");

        setVehicleVin("");
        setVehicleYear("");
        setVehicleMake("");
        setVehicleModel("");
        setAnnualMileage("");

        setValidation(new VehicleValidate());
        onCloseAction(e, carNumber) 
    }

    function isFormValid() {
        var isValid = true;
        var messages = [];
        var currentValidation = {...validationObject};

        var hasVin = vehicleVin !== "" && vehicleVin !== undefined && vehicleVin !== null;
        var hasYear = !hasVin && vehicleYear !== "" && vehicleYear !== undefined && vehicleYear !== null;
        var hasMake = !hasVin && hasYear && vehicleMake !== "" && vehicleMake !== undefined && vehicleMake !== null;
        var hasModel = !hasVin && hasYear && vehicleModel !== "" && vehicleModel !== undefined && vehicleModel !== null;
       
        var hasMiles = annualMileage !== "" && annualMileage !== undefined && annualMileage !== null ;

        if(!hasVin && !hasYear){
            isValid = false;
            messages.push(validationObject.vinError);
            currentValidation = {...currentValidation, hasVin:false }
        }

        if(hasYear && !hasMake){
            isValid = false;
            messages.push(validationObject.makeError);
            currentValidation = {...currentValidation, hasMake:false };
        }

        if(hasYear && !hasModel){
            isValid = false;
            messages.push(validationObject.modelError);
            currentValidation = {...currentValidation, hasModel:false };
        }

        if(!hasMiles){
            isValid = false;
            messages.push(validationObject.annualMilesError);
            currentValidation = {...currentValidation, hasAnnualMileage:false };
        }

        if(vehicleVin?.length < 17 || vehicleVin?.length > 17){
            isValid =false;
            messages.push(validationObject.vinLengthError);
            currentValidation = {...currentValidation, hasVinLength: false };
        }
        
        setValidation({...currentValidation })
        setErrors(messages);

        return isValid;
    }

    return (
        <>
        
            <div className={"container-edit-vehicle mb-5 " + (isExpand ? "expanded" : "")} data-index={containerKey}>
                <div className="pl-5 pt-6 pr-5 pb-6  border border-[#dee2e6]">

                    <div className=" grid grid-cols-12 sm:grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12">
                        <div className="form-group col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                            <label className="font-medium text-lg mb-5">Vehicle Identitification Number <span className="text-red-600">*</span></label>
                            <FormControl fullWidth>
                                <TextField
                                    id="txtVin"
                                    name="VIN"
                                    label="VIN"
                                    value={vehicleVin}
                                    required={true}
                                    onChange={(e)=> { 
                                        setVehicleVin(e.target.value);

                                        var vinValue = e.target.value ?? "";
                                        var hasVin = vinValue !== "";
                                        var hasYear = vehicleYear !== "" && vehicleYear !== undefined && vehicleYear !== null && validationObject.hasYear;
                                        var hasVinLength = vinValue?.length == 17;
                                        
                                        setValidation({...validationObject, hasVinLength: hasVinLength, hasVin:hasVin  });

                                        addErrorMessage(!hasVin && !hasYear, validationObject.vinError, errors, setErrors);
                                        addErrorMessage(!hasVinLength, validationObject.vinLengthError, errors, setErrors);

                                        setVehicleYear(0);
                                        setVehicleMake("");
                                        setVehicleModel("");
                                        setVehicleStyle("");
                                        
                                        onVinBlur(e.target.value)
                                    }}

                                    onBlur={(e)=>{
                                        onVinBlur(e.target.value)
                                    }}
                                    error={!validationObject.hasVin || !validationObject.hasVinLength}
                                    helperText={!validationObject.hasVin ? validationObject.vinError : !validationObject.hasVinLength ? validationObject.vinLengthError : "" }

                                    className=" mt-4"
                                />
                            </FormControl>
                            
                            <label className="font-medium italic">You can add a vehicle by providing the VIN (Vehicle Identification Number). VIN do not use the letter O 
                            or the letter S. These are either a zero (0) or a five (5).</label>

                        </div>
                        <div className=" col-span-12 pt-7 pb-7 text-[#cccccc]">
                            <hr />
                        </div>
                    </div>
                    <div className=" grid grid-cols-12 sm:grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12">
                        <div className="form-group col-span-8 md:col-span-2 xl:col-span-2 2xl:col-span-2">
                            <FormControl fullWidth>
                                <InputLabel id="lbl-ddlYear">Year</InputLabel>
                                <Select
                                    id="ddlYear"
                                    labelId="lbl-ddlYear"
                                    name="Year"
                                    label="Year"
                                    value={vehicleYear}
                                    onChange={(e) => {
                                        onYearChange(e.target.value as number)

                                        var yearValue = e.target.value ?? "";
                                        var hasVin = (vehicleVin ?? "") !== "" && validationObject.hasVin;
                                        var hasYear = e.target.value !== "";
                                        
                                        if(hasYear){
                                            
                                        setValidation({...validationObject, hasVin:true });
                                        }

                                    }
                                    }>
                                    <MenuItem value={""}></MenuItem>
                                    {
                                        years.map((v, index) => {
                                            return <MenuItem key={index} value={v}>{v}</MenuItem>
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className="pt-5 grid grid-cols-12 sm:grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12">
                        <div className="form-group col-span-8 md:col-span-2 xl:col-span-2 2xl:col-span-2">
                            <FormControl fullWidth>
                                <MakeDropDown
                                    parent={parent}
                                    key={makes}
                                    year={vehicleYear}
                                    makeOptions={makes}
                                    onMakeChangeAction={onMakeChangeAction}
                                    selectedMake={vehicleMake}
                                    hasError={ validationObject.hasYear && !validationObject.hasMake}
                                    className=""
                                />
                            </FormControl>

                        </div>
                    </div>
                    <div className="pt-5  grid grid-cols-12 sm:grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12">
                        <div className="form-group col-span-12 md:col-span-4 xl:col-span-4 2xl:col-span-4">
                            <FormControl fullWidth>
                                <ModelDropDown
                                    parent={parent}
                                    key={models}
                                    modelOptions={models}
                                    onModelChangeAction={onModelChangeAction}
                                    year={vehicleYear}
                                    make={vehicleMake}
                                    selectedModel={vehicleModel}
                                    hasError={!validationObject.hasModel}
                                    className="" />
                            </FormControl>
                        </div>
                    </div>

                    <div className="pt-5  grid grid-cols-12 sm:grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12">
                        <div className="form-group col-span-8 md:col-span-4 xl:col-span-4 2xl:col-span-4">
                            <FormControl fullWidth>
                                <TextField
                                    id="txtAnnualMilesDriven"
                                    name="AnnualMilesDriven"
                                    label="Annual mileage vehicle is driven?"
                                    value={annualMileage} 
                                    onChange={(e)=>{
                                        setAnnualMileage(e.target.value);
                                        setValidation({...validationObject, hasAnnualMileage:true });
                                    }}
                                    error={!validationObject.hasAnnualMileage}
                                    helperText={!validationObject.hasAnnualMileage ? validationObject.annualMilesError : ""}
                                />
                            </FormControl>
                        </div>
                    </div>


                    <div className="pt-10 grid grid-cols-12 sm:grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12">
                        <div className="form-group col-span-12">
                            <span onClick={(e) => { 
                                
                                onClose(e,carNumber);
                                }} className="w-1/3 sm:w-1/3 md:w-1/6 lg:w-1/6 xl:w-1/6 hover:cursor-pointer border border-[#b3b3b3] text-center float-left bg-[#f2f2f2] p-2 rounded-md active:bg-[#000000] active:text-[#fff] hover:bg-[#dfdfdf] float-left" >Cancel</span>
                            <span className={`${isSaveDisabled ? " bg-gray-500" : "bg-[#0071eb]"} w-1/3 sm:w-1/3 md:w-1/6 lg:w-1/6 xl:w-1/6 hover:cursor-pointer text-center float-right  text-[#ffffff] p-2 rounded-md active:bg-[#0a58ca] float-right w-1/3 sm:w-1/3 md:w-1/6 lg:w-1/6 xl:w-1/6 hover:cursor-pointer text-center float-right  text-[#ffffff] p-2 rounded-md active:bg-[#0a58ca] float-right`} 
                                onClick={(e) => {
                                    onSave(e);
                                }} 
                                
                               
                                >{action=="NEW" ? "Save": "Update"}</span>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default EditVehicleForm;